import { useCallback, useState } from 'react';

interface IDateFormValues {
  date: string;
}

const usePastDateSubmitGuard = <T extends IDateFormValues>(
  onSubmit: (values: T) => void | Promise<void>,
) => {
  const [pendingValues, setPendingValues] = useState<T | null>(null);

  const submitWithGuard = useCallback(
    (values: T) => {
      onSubmit(values);
    },
    [onSubmit],
  );

  const clearPending = useCallback(() => {
    setPendingValues(null);
  }, []);

  const confirmPending = useCallback(async () => {
    if (!pendingValues) {
      return;
    }

    await onSubmit(pendingValues);
    setPendingValues(null);
  }, [onSubmit, pendingValues]);

  return {
    submitWithGuard,
    pendingValues,
    clearPending,
    confirmPending,
  };
};

export default usePastDateSubmitGuard;
